<template>
  <div class="app-container-v2 no-bg" v-loading="loading">
    <div class="top-container flex vertical bg-white br6">
      <div class="title-box">
        <div class="title-left">
          <span class="title-text">账单信息（{{ billData.billNo }}）</span>
        </div>
        <div class="title-right">
          <el-button type="primary" class="button-v2" @click="costForm" :loading="downloading">成本中心汇总</el-button>
          <el-button type="primary" class="button-v2" @click="handleExport" :loading="downloading">下载</el-button>
          <el-button plain class="button-v2" @click="$back">返回列表</el-button>
        </div>
      </div>

      <div class="flex vertical center p24">
        <div v-if="$route.query.batchIds.includes(',')" class="w100 hpx40 flex acenter pl14 br4" style="background: rgba(0,147,171,0.06);">
          <img src="@/assets/img/v2/service-process/提示.png" class="size14 mr10" />
          <span class="font-14 color-1c">请注意，本次账单为合并账单</span>
        </div>
        <el-row class="w100 mt20 mb20" type="flex" justify="space-between" align="middle">
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">客户名称：</span>
              <span class="font-14 color-3">{{ billData.cusName }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">服务人数：</span>
              <span class="font-14 color-3">{{ billData.payCnt }}人</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">账单总额：</span>
              <span class="font-14 color-3">￥{{ $showMoney(billData.totalBatch) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">实发总额：</span>
              <span class="font-14 color-3">￥{{ $showMoney(billData.actTotal) }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="w100" type="flex" justify="space-between" align="middle">
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">税金总额：</span>
              <span class="font-14 color-3">￥{{ $showMoney(billData.taxTotal) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">服务费总额：</span>
              <span class="font-14 color-3">￥{{ $showMoney(billData.serviceFeeTotal) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="flex acenter">
              <span class="font-14 fw-500 color-0 text-right fwpx100">账单说明：</span>
              <span class="font-14 color-3 text-left hl22 text-ellipsis" :title="billData.billExplain">{{ billData.billExplain }}</span>
            </div>
          </el-col>
          <el-col :span="6">
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="bottom-container flex vertical bg-white br6 mt24">
      <div class="tabs-container flex aend pl4">
        <el-tabs v-model="currentTab" class="air-recover-element" @tab-click="changeTab">
          <el-tab-pane label="汇总" name="汇总" />
          <el-tab-pane label="明细" name="明细" />
        </el-tabs>
      </div>

      <div v-if="summaryData.summaryHeaderVO" v-show="currentTab === '汇总'" class="sum-body flex vertical p24 overflow-y">
        <div v-for="item in summaryDataList" class="sum-box flex vertical">
          <div class="first-level-box flex jbetween acenter">
            <span class="font-14 fw-500 color-3">{{ item.name }}</span>
            <span v-if="summrayNotMoneyColumns.includes(item.name.split(' ')[0])" class="font-14 color-1c">{{ item.columnValue }}</span>
            <span v-else class="font-14 color-1c">￥{{ $showMoney(item.columnValue) }}</span>
          </div>
          <div v-if="item.children && item.children.length" class="pl18 pr18">
            <div v-for="child in item.children" class="second-level-body flex vertical">
              <div class="second-level-box flex jbetween acenter">
                <span class="font-14 fw-500 color-3">{{ child.name }}</span>
                <span v-if="summrayNotMoneyColumns.includes(child.name.split(' ')[0])" class="font-14 color-1c">{{ child.columnValue }}</span>
                <span v-else class="font-14 color-1c">￥{{ $showMoney(child.columnValue) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="render" v-show="currentTab === '明细'" class="flex vertical p24" style="height: calc(100vh - 429px);">
        <air-table
            ref="airTable"
            class="table-v2"
            :show-checkbox="false"
            :show-operation="false"
            align="center"
            :columns="columns"
            :data="tableData"
        ></air-table>

        <vxe-pager
            class="pager-v2"
            background
            :current-page.sync="queryParams.page"
            :page-size.sync="queryParams.limit"
            :total="total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
            @page-change="getData"
        ></vxe-pager>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'
import * as apiBill from '@/api/v2/service-process/bill'

export default {
  name: 'ServiceProcessBillDetail',
  data() {
    return {
      render: false,
      loading: true,
      currentTab: '汇总',
      billData: {},
      summaryData: {},
      summrayNotMoneyColumns: ['账单月份', '服务人数', '外币种类', '外币汇率'],
      queryParams: {
        page: 1,
        limit: 20,
        type: 'all'
      },
      total: 0,
      columns: [],
      tableData: [],
      dictMap: {},
      downloading: false
    }
  },
  computed: {
    summaryDataList() {
      if (!this.summaryData.summaryHeaderVO) return []
      let list = []
      for (let i = 0; i < 3; i++) {
        list = list.concat(this.summaryData[`settingList${i}`].filter(item => {
          if (item.nullHidden && !item.columnValue) return false
          if (item.children && item.children.length) {
            item.children = item.children.filter(child => !(child.nullHidden && !child.columnValue))
          }
          return true
        }))
      }
      return list
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.queryParams.id = this.$route.query.id
      this.queryParams.batchId = this.$route.query.batchIds.split(',')[0]
      this.queryParams.cusId = this.$route.query.cusId
      await this.getDict()
      await this.getData()
      this.getTableData()
    },
    async getData() {
      try {
        await api.getBillInfo(this.queryParams.id).then(res => {
          this.billData = res.data.data
        })
        await api.getBillSummaryInfo({cusId: this.queryParams.cusId, billId: this.queryParams.id}).then(res => {
          this.summaryData = res.data.data[0]
        })
        await api.getBillHeader(this.queryParams.batchId).then(res => {
          this.columns = res.data.data
        })
      } catch (e) {
        this.$message.error('获取账单明细失败');
      }
    },
    getTableData() {
      this.loading = true
      api.getBillDetail(this.queryParams).then(res => {
        this.tableData = this.$handleTableDict(res.data.data.records, this.dictMap, '')
        this.total = res.data.data.total
        this.loading = false
      }).catch(e => {
        this.$message.error('获取账单明细失败');
        this.loading = false
      }).finally(()=>{
        this.loading = false
      })
    },
    getDict() {
      apiBill.queryBillListByPage({
        page: 1,
        limit: 20,
        cusId: this.$userInfo.cusId
      }).then(res => {
        this.handleDictMap(res.data.data.billCodeItems)
      })
    },
    handleDictMap(dict) {
      if (!Object.keys(dict).length) return
      this.dictMap.identityType = this.$arrayToObj(dict['1001'], 'codeItemId')
      this.dictMap.national = this.$arrayToObj(dict['1008'], 'codeItemId')
      this.dictMap.bankType = this.$arrayToObj(dict['1016'], 'codeItemId')
      this.dictMap.taxArea = this.$arrayToObj(dict['1036'], 'codeItemId')
      this.dictMap.operateWay = this.$arrayToObj(dict['2002'], 'codeItemId')
      this.dictMap.taxType = this.$arrayToObj(dict['2004'], 'codeItemId')
      this.dictMap.taxNominal = this.$arrayToObj(dict['3006'], 'codeItemId')
      this.dictMap.taxDeclareWay = this.$arrayToObj(dict['3008'], 'codeItemId')
      this.dictMap.batchProperty = this.$arrayToObj(dict['3050'], 'codeItemId')
      this.dictMap.payWay = this.$arrayToObj(dict['3054'], 'codeItemId')
      this.dictMap.payStatus = this.$arrayToObj(dict['3056'], 'codeItemId')
      this.dictMap.specialAdditionalMethod = this.$arrayToObj(dict['3062'], 'codeItemId')
      this.dictMap.cumulativeMethod = this.$arrayToObj(dict['3062'], 'codeItemId')
      this.dictMap.serviceFeeNature = this.$arrayToObj(dict['3067'], 'codeItemId')
      this.dictMap.cusId = this.$arrayToObj(dict['cusId'], 'codeItemId')
    },
    changeTab() {
      // 首次切换tab时再渲染表格，否则会显示异常
      this.render = true
    },
    handleExport() {
      this.downloading = true
      api.exportNoticeDetail({
        id: this.queryParams.id,
        isOtherBiz: false,
        contractType: '',
        contractCode: '',
        cusId: this.queryParams.cusId
      }).then(res=>{
        this.$downloadFile(res)
      }).finally(() => this.downloading = false)
    },
    costForm() {
      // 获取所需参数
      const billId = this.billData.id;          // 账单ID
      const cusId = this.billData.cusId;        // 客户ID
      const cusName = this.billData.cusName;       // 客户名称
      // 若有 isMergeBill / isCusGroup 则从数据中取，若没有则传空或默认值
      const isMergeBill = this.billData.isMergeBill || '';
      const isCusGroup = this.billData.isCusGroup || '';

      this.$router.push({
        path: '/v2/service-process/bill/detail/cost-form',
        query: {
          billId,
          cusId,
          cusName,
          isMergeBill,
          isCusGroup
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.top-container {
  height: 249px;
  flex: 0 0 249px;
}
.bottom-container {
  height: calc(100vh - 369px);
}
.tabs-container {
  height: 60px;
  flex: 0 0 60px;
  border-bottom: 1px solid #E8E8E8;

  ::v-deep {
    .el-tabs__content {
      display: none !important;
    }
    .el-tabs__header {
      margin: 0 36px 0 0 !important;
    }
    .el-tabs__nav-wrap:after {
      background-color: transparent !important;
    }
    .el-tabs__item {
      height: 24px !important;
      font-size: 18px !important;
      font-family: PingFangSC-Medium, PingFang SC !important;
      font-weight: 500 !important;
      color: #1C1C1C !important;
      line-height: 24px !important;
      margin-bottom: 15px !important;

      &:hover, &.is-active {
        color: #FF9601 !important;
      }
    }
    .el-tabs__active-bar {
      background-color: #FF9601 !important;
    }
  }
}
.sum-box {
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
  .first-level-box {
    height: 46px;
    background: #FAFAFA;
    border-radius: 4px;
    padding: 0 38px 0 24px;
  }
  .second-level-body {
    margin-top: 14px;
    padding: 14px;
    background: rgba(0,147,171,0.04);
    border-radius: 4px;

    .second-level-box {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
